function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.dom-collections.for-each.js";
import Showmore from 'integration-web-core--socle/js/assets/modules/_showmore.js';
import Layer from "@mozaic-ds/freemarker/js/modules/_layer";
import { legalTermClickEvent, cdlEvent } from './trackingEvents';
import { hitEventTms } from 'integration-web-core--socle/js/assets/commons/_tms.js';
var layer = new Layer({
  'classContent': 'js-layer-info',
  'isScrollEdge': false
});
function handleTrackingEvent() {
  var currentLegalTermLinks = document.querySelectorAll('.m-category_box_text_currentLegalTerm');
  var oldLegalTermLinks = document.querySelectorAll('.m-category_box_text_previousLegalTerm');
  currentLegalTermLinks.forEach(function (link) {
    link.addEventListener('click', function () {
      hitEventTms(link, cdlEvent, JSON.stringify(legalTermClickEvent(link.innerText, false)));
    });
  });
  oldLegalTermLinks.forEach(function (link) {
    link.addEventListener('click', function () {
      hitEventTms(link, cdlEvent, JSON.stringify(legalTermClickEvent(link.innerText, true)));
    });
  });
}
document.addEventListener('DOMContentLoaded', function () {
  var links = document.querySelectorAll('.layer-links');
  handleTrackingEvent();
  links.forEach(function (link) {
    link.addEventListener('click', function () {
      var legalTermId = link.dataset.id;
      var categoryId = link.dataset.id1;
      lm.fetch({
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        },
        url: "/legal-space/services/termofuse/categories/".concat(categoryId, "/legalTerms/").concat(legalTermId, "/previousversion"),
        success: function () {
          var _success = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(response) {
            var result, layerContent, h1, cguListUlElement;
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  result = JSON.parse(response);
                  layerContent = document.querySelector('.m-previous_element'); //Clean layer content
                  while (layerContent.firstChild) {
                    layerContent.removeChild(layerContent.firstChild);
                  }

                  //Layer title
                  h1 = document.createElement('h1');
                  h1.textContent = result.title + " : ";
                  layerContent.insertBefore(h1, layerContent.firstChild);

                  //List of cgu links
                  cguListUlElement = document.createElement('ul');
                  if (result.previousValues.length > 0) {
                    result.previousValues.forEach(function (previousValue) {
                      var _previousValue$media;
                      if ((_previousValue$media = previousValue.media) !== null && _previousValue$media !== void 0 && _previousValue$media.url && previousValue !== null && previousValue !== void 0 && previousValue.updateDate) {
                        var pdfUrl = previousValue.media.url;
                        var title = previousValue.title;
                        var updateDate = new Date(previousValue.updateDate);
                        if (updateDate && pdfUrl && title) {
                          var cugListItem = document.createElement('li');
                          var _link = document.createElement('a');
                          _link.href = pdfUrl;
                          _link.target = "_blank";
                          _link.rel = "noopener noreferrer";
                          _link.textContent = title;
                          _link.classList.add('m-previous_legalTerms');
                          cugListItem.appendChild(_link);
                          cugListItem.innerHTML += ' - ' + updateDate.toLocaleDateString();
                          cguListUlElement.appendChild(cugListItem);
                        }
                      }
                    });
                  }
                  layerContent.appendChild(cguListUlElement);
                case 1:
                  return _context.a(2);
              }
            }, _callee);
          }));
          function success(_x) {
            return _success.apply(this, arguments);
          }
          return success;
        }(),
        error: function error(val) {
          console.warn(val);
        }
      });
      layer.open();
    });
  });
});
var closeInfoLayer = document.querySelector('.js-close-layer-info');
closeInfoLayer.addEventListener('click', function () {
  layer.close();
});
var backButton = document.querySelector('.m-category_backButton_link');
backButton.addEventListener("click", function () {
  window.history.back();
});
lm.DOMReady(function () {
  var optionShowMore = {
    id: "js-showmore",
    label: {
      more: 'Voir plus',
      less: 'Voir moins'
    },
    initialHeight: '6rem'
  };
  new Showmore(optionShowMore);
});